<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "DeathAndDisabilityBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "身故及完全失能保險金",
        pageBlock: ["periodMulti", "formulaMulti", "maxMulti"],
        showUpper: false,
        showHint: true,
        showCoverageItems: false,
      },
      defaultForm: {
        periodType: 7,
        max_period: "",
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        from.name === "MaintainForm8" ||
        from.name === "CreateForm903" ||
        from.name === "TerminationFeeAndReserveMaintain"
      ) {
        vm.pageControl.settingType = 2;
      }
    });
  },
};
</script>